/* Hand-written GraphQL documents for the Catalog models (CONF-106 part 1).
   Mirrors the generated mutations.js style; regenerate/replace if codegen is
   re-run after the schema deploy. */

export const createCatalogComponent = /* GraphQL */ `
  mutation CreateCatalogComponent($input: CreateCatalogComponentInput!) {
    createCatalogComponent(input: $input) {
      id vendor effectiveFrom componentSku kind value recordedAt actor version supersedes createdBy
    }
  }
`;

export const createCatalogComposition = /* GraphQL */ `
  mutation CreateCatalogComposition($input: CreateCatalogCompositionInput!) {
    createCatalogComposition(input: $input) {
      id vendor productSku components version supersedes createdBy
    }
  }
`;

export const listCatalogComponents = /* GraphQL */ `
  query ListCatalogComponents($filter: ModelCatalogComponentFilterInput, $limit: Int, $nextToken: String) {
    listCatalogComponents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { id vendor effectiveFrom componentSku kind value recordedAt actor version }
      nextToken
    }
  }
`;

export const listCatalogCompositions = /* GraphQL */ `
  query ListCatalogCompositions($filter: ModelCatalogCompositionFilterInput, $limit: Int, $nextToken: String) {
    listCatalogCompositions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { id vendor productSku components version }
      nextToken
    }
  }
`;
